import * as React from 'react';
import { FC } from 'react';
import moment from 'moment';
import { Match, Day as TournamentDay } from './types';
import locales from './locales';

const Title = () => (
  <div className="calendar_top">
    <i className="rs-icon-calendar calendar_icon" />
    <h2 className="calendar_title">{locales().schedule}</h2>
  </div>
);

const Week = () => (
  <div className="calendar_week c-week">
    {(locales().days as string[]).map((w) => (
      <div key={w} className="c-week_day">
        {w}
      </div>
    ))}
  </div>
);

type DayStatus = 'fail' | 'success' | 'disabled' | 'game';

type StatusIconProps = {
  status: DayStatus;
};

const StatusIcon = ({ status }: StatusIconProps) => {
  switch (status) {
    case 'fail':
      return <i className="rs-icon-exclamation-triangle" />;
    case 'success':
      return <i className="rs-icon-check-circle" />;
    default:
      return null;
  }
};

const dayStatus: (matches: Match[] | undefined) => DayStatus = (matches) => {
  if (!matches || matches.length === 0) return 'disabled';
  if (matches.find((match) => match.result === 'success')) return 'success';
  return matches.find((match) => match.result === 'fail') ? 'fail' : 'game';
};

type DayProps = {
  date: moment.Moment;
  day: TournamentDay | undefined;
  selected: boolean;
  onSelect: OnSelect;
};

const Day = ({ date, day, selected, onSelect }: DayProps) => {
  const status = dayStatus(day?.matches);
  const d = date.format('DD');
  const m = locales()[date.month() === 5 ? 'june' : 'july'];

  return (
    <div
      className={`calendar_day c-day calendar_day__${status} ${selected ? 'selected' : ''}`}
      aria-label={`${d} ${m}`}
      onClick={status !== 'disabled' && !selected && day ? () => onSelect(day) : undefined}
    >
      <div className="c-day_top">
        <div className="c-day_date">{d}</div>
        <div className="c-day_month">{m}</div>
        <div className="c-day_status">
          <StatusIcon status={status} />
        </div>
      </div>
      <div className="c-day_game">
        <span>{day?.game || ''}</span>
      </div>

      {status !== 'disabled' ? (
        <a href="#to_matches" className="c-day_anchor" aria-label="anchor">
          &nbsp;
        </a>
      ) : null}
    </div>
  );
};

const dayForDate = (date: moment.Moment, days: TournamentDay[]) => {
  const dateStr = date.format('YYYY-MM-DD');
  return days.find((d) => d.date === dateStr);
};

const dates = [...Array(35).keys()].map((idx) => moment.utc([2021, 5, 7]).add(idx, 'days'));

type OnSelect = (day: TournamentDay) => void;

const Days = ({ days, selectedDay, onSelect }: CalendarProps) => (
  <div className="calendar_days">
    {dates.map((date) => {
      const day = dayForDate(date, days);
      return (
        <Day key={date.toString()} date={date} day={day} selected={!!day && day === selectedDay} onSelect={onSelect} />
      );
    })}
  </div>
);

type CalendarProps = { days: TournamentDay[]; selectedDay: TournamentDay | undefined; onSelect: OnSelect };

const Calendar: FC<CalendarProps> = (props) => (
  <div className="euro_calendar">
    <Title />
    <Week />
    <Days {...props} />
    <div id="to_matches" />
  </div>
);

export default Calendar;
